export { alternatePathsField } from './fields/alternatePathsField.js'
export { slugField } from './fields/slugField.js'
export { payloadPagesPlugin } from './plugin.js'
export type { IncomingPageCollectionConfig as PageCollectionConfig } from './types/PageCollectionConfig.js'
export type {
  IncomingPageCollectionConfigAttributes as PageCollectionIncomingConfigAttributes,
  PageCollectionConfigAttributes,
} from './types/PageCollectionConfigAttributes.js'
export type { PagesPluginConfig } from './types/PagesPluginConfig.js'
export type { IncomingRedirectsCollectionConfig as RedirectsCollectionConfig } from './types/RedirectsCollectionConfig.js'
export type {
  IncomingRedirectsCollectionConfigAttributes as RedirectsCollectionIncomingConfigAttributes,
  RedirectsCollectionConfigAttributes,
} from './types/RedirectsCollectionConfigAttributes.js'
export { childDocumentsOf, hasChildDocuments } from './utils/childDocumentsOf.js'
